module.exports = __webpack_public_path__ + "img/avenir-text.b4b6d0e3.png";